import type { SVGProps } from "react";
export interface CodeAIIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CodeAIIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CodeAIIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 18V6A4.125 4.125 0 0 1 6 1.875h6.54a1.125 1.125 0 0 1 0 2.25H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875v-6.54a1.125 1.125 0 0 1 2.25 0V18A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18"
      />
      <path
        fill={color}
        d="M9.205 8.955a1.125 1.125 0 1 1 1.59 1.59l-1.454 1.456 1.454 1.454.078.085a1.126 1.126 0 0 1-1.583 1.582l-.085-.076-2.25-2.25a1.125 1.125 0 0 1 0-1.59l2.25-2.25Zm4 0a1.124 1.124 0 0 1 1.505-.078l.086.078 2.25 2.25a1.126 1.126 0 0 1 0 1.59l-2.25 2.25a1.125 1.125 0 0 1-1.59-1.59l1.454-1.454-1.455-1.455-.078-.086a1.124 1.124 0 0 1 .078-1.505M19 .875c.507 0 .952.34 1.085.83l.257.938.061.18c.171.407.521.717.954.835l.939.257a1.125 1.125 0 0 1 0 2.17l-.94.257a1.45 1.45 0 0 0-.953.835l-.061.18-.257.939a1.125 1.125 0 0 1-2.17 0l-.257-.94a1.45 1.45 0 0 0-1.015-1.014l-.939-.257a1.125 1.125 0 0 1 0-2.17l.94-.257c.493-.135.88-.52 1.014-1.015l.257-.939.064-.176A1.13 1.13 0 0 1 19 .875m0 3.87q-.12.134-.255.255.133.12.255.253.12-.133.253-.253A4 4 0 0 1 19 4.745"
      />
    </svg>
  );
}
